export const TRANSLATIONS_PT_HOME_PULSE_AND_CALENDAR = {
  "home.pulse.eyebrow": "Motor de classificação em tempo real",
  "home.pulse.subtitle": "Monitoramos como o Innovadoc IA está rotulando seus documentos agora.",
  "home.pulse.originNote": "Daqui nascem as datas, prioridades e ações exibidas no restante do home.",
  "home.pulse.state.ok": "Tudo certo",
  "home.pulse.state.processing": "Atenção necessária",
  "home.pulse.state.attention": "Crítico",
  "home.pulse.summary.documents": "Documentos já interpretados",
  "home.pulse.summary.artifacts": "Tipos de artefato entendidos",
  "home.pulse.summary.categories": "Categorias reconhecidas",
  "home.pulse.summary.overdue": "Vencidos",
  "home.pulse.summary.upcoming": "Próximos",
  "home.pulse.modal.eyebrow": "Datas-chave",
  "home.pulse.modal.overdueTitle": "Documentos vencidos",
  "home.pulse.modal.upcomingTitle": "Documentos próximos",
  "home.pulse.modal.countLabel": "Mostrando",
  "home.pulse.modal.ofLabel": "de",
  "home.pulse.modal.dueLabelOverdue": "Vencido em",
  "home.pulse.modal.dueLabelUpcoming": "Vence em",
  "home.pulse.modal.roleLabel": "Função",
  "home.pulse.modal.stateLabel": "Status",
  "home.pulse.modal.actionLabel": "Ação",
  "home.pulse.modal.close": "Fechar",
  "home.pulse.modal.viewDocument": "Ver documento",
  "home.pulse.modal.openQueue": "Ver pendências",
  "home.pulse.modal.overdueEmpty": "Não há documentos vencidos.",
  "home.pulse.modal.upcomingEmpty": "Não há documentos próximos.",
  "home.pulse.modal.limitedHint": "Lista resumida. Veja suas pendências para ver tudo.",
  "home.pulse.artifactTypes.title": "Tipos de artefato detectados",
  "home.pulse.artifactTypes.showMore": "Ver mais",
  "home.pulse.artifactTypes.showLess": "Ver menos",
  "home.pulse.recentClassifications.title": "Classificações recentes",
  "home.pulse.recentClassifications.countLabel": "registros",
  "home.pulse.recentClassifications.empty": "Sem classificações na última hora.",
  "home.pulse.empty": "Nenhum dado de pulso disponível.",
  "home.datesSummary.eyebrow": "Datas importantes",
  "home.datesSummary.title": "Datas importantes dos seus documentos",
  "home.datesSummary.totalLabel": "documentos com datas próximas",
  "home.datesSummary.description": "Renovações e prazos próximos que vale a pena não perder de vista.",
  "home.datesSummary.connection": "Ordenadas pelo que vence primeiro.",
  "home.datesSummary.roleLabel": "Responsável",
  "home.datesSummary.role.renewal": "Renovações",
  "home.datesSummary.role.audit": "Auditorias",
  "home.datesSummary.role.expiration": "Vencimentos",
  "home.datesSummary.role.compliance": "Compliance",
  "home.datesSummary.tooltip": "Detectadas automaticamente nos seus documentos.",
  "home.datesSummary.clearFilter": "Limpar filtro por papel",
  "home.datesSummary.panelEyebrow": "Datas importantes",
  "home.datesSummary.panelTitle": "Datas importantes dos seus documentos",
  "home.datesSummary.panelSubtitle": "Documentos e suas datas próximas que vale a pena revisar.",
  "home.datesSummary.closePanel": "Fechar painel de datas",
  "home.datesSummary.panelQueueCta": "Ver estes documentos",
  "home.datesSummary.panelFilterActive": "Filtro ativo: exibindo apenas este papel.",
  "home.datesSummary.panelEmpty": "Nenhuma data detectada para mostrar.",
  "home.datesSummary.empty": "Nenhuma data detectada por enquanto.",
  "home.datesSummary.filterSaved": "Preferência salva.",
  "home.datesSummary.state.active": "Ativa",
  "home.datesSummary.state.upcoming": "Próxima",
  "home.datesSummary.state.resolved": "Resolvida",
  "home.datesSummary.previewTitle": "Próximas datas",
  "home.datesSummary.previewSubtitle": "por proximidade",
  "home.datesSummary.previewAction": "Ver lista",
  "home.datesSummary.previewChangeRole": "Alterar responsável",
  "home.datesSummary.previewOpenCalendar": "Abrir calendário",
  "home.stats.title": "Como o sistema entende seus documentos hoje",
  "home.stats.description": "Acompanhamos essas métricas para garantir que a classificação permaneça saudável.",
  "home.stats.note": "Elas sustentam cada recomendação e as suas pendências.",
  "home.stats.label.pending_documents": "Documentos pendentes",
  "home.stats.label.evaluated_documents": "Documentos avaliados",
  "home.stats.label.oldest_pending_age_seconds": "Idade do pendente mais antigo (segundos)",
  "home.stats.label.last_evaluation_age_seconds": "Idade da última avaliação (segundos)",
  "home.stats.label.evaluation_duration_p95_ms": "Duração da avaliação p95 (ms)",
  "home.stats.label.evaluation_duration_p99_ms": "Duração da avaliação p99 (ms)",
  "home.stats.label.ranker_duration_p95_ms": "Duração do ranker p95 (ms)",
  "home.stats.label.ranker_duration_p99_ms": "Duração do ranker p99 (ms)",
  "home.stats.label.error_rate": "Taxa de erro",
  "home.stats.label.throughput_eval_per_hour": "Avaliações por hora",
  "home.stats.label.throughput_rank_per_hour": "Ranking por hora",
  "home.stats.empty": "Nenhuma métrica disponível ainda.",
  "home.decisionPulse.eyebrow": "Pulso operacional",
  "home.decisionPulse.headline.alert": "Algumas decisões exigem atenção imediata",
  "home.decisionPulse.headline.watch": "A carga está estável, mas há decisões próximas",
  "home.decisionPulse.headline.calm": "Tudo está sob controle por enquanto",
  "home.decisionPulse.copy.actNow": "exigem ação imediata",
  "home.decisionPulse.copy.overdue": "estão vencidas",
  "home.decisionPulse.copy.actSoon": "devem ser resolvidas em breve",
  "home.decisionPulse.copy.monitoring": "decisões seguem em monitoramento",
  "home.decisionPulse.copy.empty": "Não há decisões ativas neste momento.",
  "home.decisionPulse.connection.label": "SSE",
  "home.decisionPulse.connection.connecting": "Conectando",
  "home.decisionPulse.connection.connected": "Tempo real",
  "home.decisionPulse.connection.disconnected": "Desconectado",
  "home.decisionPulse.connection.error": "Com atraso",
  "home.calendar.eyebrow": "Calendário",
  "home.calendar.title": "Calendário de decisões",
  "home.calendar.description": "Explore decisões por data operacional sem sair do painel de detalhe existente.",
  "home.calendar.empty": "Não há decisões com data para este intervalo.",
  "home.calendar.emptyMonth": "Sem decisões datadas",
  "home.calendar.undated": "Decisões sem data",
  "home.calendar.today": "Hoje",
  "home.calendar.previous": "Anterior",
  "home.calendar.next": "Próximo",
  "home.calendar.moreEntries": "a mais",
  "home.calendar.emptyDay": "Não há eventos monitorados neste dia.",
  "home.calendar.granularity.week": "Semana",
  "home.calendar.granularity.month": "Mês",
  "home.calendar.granularity.year": "Ano",
  "home.knowledgeExpirations.title": "Próximos vencimentos de documentos",
  "home.knowledgeExpirations.viewAll": "Ver todos",
  "home.knowledgeExpirations.empty": "Nenhum vencimento próximo nos seus documentos.",
  "home.knowledgeExpirations.errorTitle": "Não foi possível carregar os vencimentos",
  "home.knowledgeExpirations.errorMessage": "Tente novamente em alguns segundos.",
  "home.knowledgeEntities.title": "Entidades com atividade recente",
  "home.knowledgeEntities.viewAll": "Explorar",
  "home.knowledgeEntities.sources": "fontes",
  "home.knowledgeEntities.empty": "Ainda não há entidades com atividade recente.",
  "home.knowledgeEntities.errorTitle": "Não foi possível carregar as entidades",
  "home.knowledgeEntities.errorMessage": "Tente novamente em alguns segundos.",
  "home.calendar.agenda.empty": "Nenhuma decisão agendada neste mês.",
  "home.calendar.agenda.today": "Hoje",
  "home.calendar.agenda.todayBadge": "Hoje",
  "home.calendar.agenda.previousMonth": "Mês anterior",
  "home.calendar.agenda.nextMonth": "Próximo mês",
  "home.viewMode.label": "Modo de visualização",
};
